import { render, staticRenderFns } from "./TutorialMessage.vue?vue&type=template&id=6138d923&scoped=true&"
import script from "./TutorialMessage.vue?vue&type=script&lang=js&"
export * from "./TutorialMessage.vue?vue&type=script&lang=js&"
import style0 from "./TutorialMessage.vue?vue&type=style&index=0&id=6138d923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138d923",
  null
  
)

export default component.exports